import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify, {
  customProperties: true,
  iconfont: 'fa',
  lang: {
    locales: { fr },
    current: 'fr',
  },
  theme: {
    secondary: '#004D40',
    primary: '#4DB6AC',
  },
});
